import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { fetchPartnerPerformance } from "../../../services/automapPartnershipApi";
import { AdminPartnerDetailNav, usePartnerIdParam } from "./AdminPartnersShared";

export default function AdminPartnerPerformancePage() {
  const partnerId = usePartnerIdParam();
  const [range, setRange] = useState("last_30_days");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchPartnerPerformance(partnerId, range)
      .then((res) => setData(res.performance))
      .finally(() => setLoading(false));
  }, [partnerId, range]);

  const t = data?.totals || {};

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliado" title="Performance" description={data?.partner?.name} />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnerDetailNav partnerId={partnerId} active="performance" />
      <main className="admin-console__main wrap">
        <select value={range} onChange={(e) => setRange(e.target.value)}>
          <option value="today">Hoy</option>
          <option value="last_7_days">7 días</option>
          <option value="last_30_days">30 días</option>
          <option value="this_month">Este mes</option>
        </select>
        {loading ? <p>Cargando…</p> : (
          <>
            <div className="admin-dashboard__metrics-grid" style={{ marginTop: "1rem" }}>
              <div className="admin-dashboard__metric-card"><span>Leads</span><strong>{t.leads}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Calificados</span><strong>{t.qualified}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Convertidos</span><strong>{t.converted ?? "—"}</strong></div>
              <div className="admin-dashboard__metric-card"><span>Perdidos</span><strong>{t.lost}</strong></div>
            </div>
            <section className="dealer-state-box">
              <h3>Por ciudad</h3>
              <ul>{Object.entries(data?.byCity || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Por origen</h3>
              <ul>{Object.entries(data?.bySource || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Por banda de precio</h3>
              <ul>{Object.entries(data?.byPriceBand || {}).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
            </section>
            <p className="muted">Conversión y respuesta aliado: TODO placeholder billing/portal.</p>
          </>
        )}
      </main>
    </AdminPageLayout>
  );
}
